/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';
import { gridUserDataSource } from '../../UserServices';
import { Container } from './styles';

function Lista() {
  const [form, setForm] = useState({ idPessoaEmpresa: '' });
  const [isSelected, setIsSelected] = useState(false);
  const history = useHistory();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  const [companyData, setCompanyData] = useState([{}]);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setCompanyData(data);
        });
    }
    getData();
  }, []);

  return (
    <Container>
      <FormGroup>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione a empresa:"
          form={form}
          valueKey="idPessoaEmpresa"
          labelKey="razaoSocialNome"
          setForm={setForm}
          value={form.idPessoaEmpresa}
          options={companyData}
          placeholder="Escolha uma opção"
          state="idPessoaEmpresa"
          onChange={() => {
            setIsSelected(false);
            setTimeout(() => {
              setIsSelected(true);
            }, 500);
          }}
        />
      </FormGroup>

      {!isSelected ? (
        ''
      ) : (
        <>
          <section>
            <div className="sec1">
              <h1>Usuários</h1>
            </div>
            <div className="add">
              <Link to="/user/register" className="link">
                <FaPlus />
              </Link>
            </div>
          </section>

          <DataGrid
            dataSource={gridUserDataSource(form.idPessoaEmpresa)}
            remoteOperations
            showBorders
            allowColumnReordering
            allowColumnResizing
            columnAutoWidth
            onOptionChanged={handleOptionChange}
          >
            <Editing mode="row" useIcons allowDeleting />
            <Pager
              visible
              showPageSizeSelector
              allowedPageSizes={[10, 15, 30]}
              showInfo
            />
            <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
            <FilterRow
              visible={filterOptions.showFilterRow}
              applyFilter={filterOptions.currentFilter}
            />
            <Column
              dataField="id"
              caption="ID usuário"
              filterOperations={false}
              alignment="left"
              allowFiltering
              width={150}
            >
              <HeaderFilter groupInterval={70} />
            </Column>
            <Column
              dataField="login"
              caption="Login usuário"
              filterOperations={false}
              alignment="left"
              width={250}
              allowFiltering
            >
              <HeaderFilter groupInterval={70} />
            </Column>
            <Column
              dataField="email"
              caption="Email usuário"
              filterOperations={false}
              alignment="left"
              allowFiltering={false}
              width={150}
            />
            <Column type="buttons" caption="Vincular grupo" width={150}>
              <Button
                hint="Vincular"
                visible
                icon="link"
                width={150}
                onClick={() => history.push('/group/user')}
              />
            </Column>
            <Column type="buttons" caption="Ações" width={100}>
              <Button
                hint="Editar"
                visible
                icon="edit"
                onClick={(e) => history.push(`/user/update/${e.row.data.id}`)}
              />
              <Button name="delete" visible hint="Deletar" icon="trash" />
            </Column>
          </DataGrid>
        </>
      )}
    </Container>
  );
}

export default Lista;
